module.exports = __webpack_public_path__ + "static/5-135af8d4fc324ca1627c2a8aad30ce5c.wav";